import {Slider} from './Slider';
import {SliderLabel} from './SliderLabel';
import {RangeSlider} from './RangeSlider';
import {ControlBlock} from './ControlBlock';
import {AnimationZoom} from './AnimationZoom';
import {AnimationBlock} from './AnimationBlock';
import {AnimationSlider} from './AnimationSlider';
import {RangeSliderLabels} from './RangeSliderLabels';
import {SwitchButtonBlock} from './SwitchButtonBlock';
import classNames from './WidgetStyles';

export const WidgetComponents = {
  Slider,
  SliderLabel,
  RangeSlider,
  ControlBlock,
  AnimationZoom,
  AnimationBlock,
  AnimationSlider,
  RangeSliderLabels,
  SwitchButtonBlock,
};

export const WidgetStyles = {
  classNames,
}
